export default "__VITE_ASSET__dfcde755__"